<template>
	<div
		class="row p-3"
		:class="$style.row"
	>
		<div class="col-7 d-none d-xl-block text-center">
			<img
				alt="GestiOS Data Software"
				class="img-fluid p-5"
				src="@/system/assets/images/public/offline.png"
			>
		</div>

		<div
			class="
				col-10 offset-1
				col-md-8 offset-md-2
				col-xl-5 offset-xl-0
				text-center text-xl-right
			"
		>
			<img
				alt="GestiOS Data Software"
				class="d-block d-xl-none img-fluid mx-auto p-5"
				src="@/system/assets/images/public/offline.png"
			>

			<h1 class="mb-3 text-white font-size-40 text-uppercase">
				<span
					class="
						d-block d-sm-inline-block
						animate__animated animate__shakeX animate__delay-1s
						font-size-50
					"
				>🌎</span> Error de red
			</h1>

			<div class="text-gray-4 mb-3 font-size-21 text-normal text-sm-justify">
				No está costando mucho conectarte a los servicios de GestiOS.
				Asegúrate de tener buena conexión.
			</div>
		</div>
	</div>
</template>
<script>

export default {
	name: 'ErrorOffline'
};
</script>
<style lang="scss" module>

.row{
	background-color: $dark;
	background-size: auto 100%;
	height: 100vh;
	align-items: center;
	display: flex;
}

.img{
	max-width: 700px;
}

</style>
